module.exports = __webpack_public_path__ + "static/media/ice-hockey.014ae8bc.svg";